import { getCookieValue, setCookieValue } from './helpers';
import { getTopLevelDomainOf } from './routeHelpers';

const cookieNames = {
  newsletterDisplayed: 'newsletterDisplayed',
  regionalDisplayed: 'regionalDisplayed',
};

const setTopLevelSessionLongCookie = (key: string, value: string, domain: string) => {
  const topLevelDomain = getTopLevelDomainOf(domain);
  const cookieDomain = topLevelDomain === 'localhost' ? topLevelDomain : `.${topLevelDomain}`;
  setCookieValue(key, value, { path: '/', domain: cookieDomain });
};

const setNewsletterDisplayedSessionCookie = (basePathWeb: string) => {
  setTopLevelSessionLongCookie(cookieNames.newsletterDisplayed, '1', basePathWeb);
};
const isSetNewsletterDisplayedCookie = () => {
  return !!getCookieValue(cookieNames.newsletterDisplayed);
};

const setRegionalDisplayedSessionCookie = (basePathWeb: string) => {
  setTopLevelSessionLongCookie(cookieNames.regionalDisplayed, '1', basePathWeb);
};
const isSetRegionalDisplayedCookie = () => {
  return !!getCookieValue(cookieNames.regionalDisplayed);
};

export {
  setNewsletterDisplayedSessionCookie,
  isSetNewsletterDisplayedCookie,
  setRegionalDisplayedSessionCookie,
  isSetRegionalDisplayedCookie,
};
